import { render, staticRenderFns } from "./pos-addCustomer.vue?vue&type=template&id=11ac0e54"
import script from "./pos-addCustomer.vue?vue&type=script&lang=js"
export * from "./pos-addCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports